<!------------------------------------------------------------------------------
 File: DateChooser 
 Created by keni.
 with: IntelliJ IDEA
 Date: 24/04/2018
 Time: 10:12
 Documentation: http://amsul.ca/pickadate.js/api/
------------------------------------------------------------------------------->
<template>
    <div>
        <div class="md-form" v-if="show_form == true">
            <input placeholder="Selected date" type="text" :id="id" class="form-control datepicker">
            <label :for="id">Week</label>
        </div>
        <div v-else class="">
            <input placeholder="Selected date" type="hidden" :id="id" class="datepicker">
        </div>
    </div>

</template>

<script>
    import {_} from 'underscore';

    export default {
        name: "",
        components: {},
        props: [
            'settings',
            'trigger_open'
        ],
        created() {
        },
        destroyed() {
        },
        mounted() {
            let _this = this,
                setForm;
// console.log('this.settings',this.settings);
            if ('show_form' in this.settings) {
                this.show_form = this.settings.show_form;
            }

            _this.$nextTick(function () {
                this.init();
            })
        },
        data() {
            return {
                show_form: true,
                id: _.uniqueId('date-pick'),
                title: 'week',
                input: Object,
                picker: Object
            }
        },
        methods: {
            init() {
                let _this = this, elm =  $('#' + _this.id),value = '';

                _this.input = elm.pickadate({
                    set: {
                        max: new Date()
                    },
                    onSet: function (val) {
	                    // console.log('onSet');
                        // value = this.component.$node[0].value;
                        // console.log('val',val,value,'onSet()');
                        // _this.dateChanged(value);
                    },
	                /**
                     *
	                 * @param value
	                 */
                    onClose: function(value){
                    	// console.log('onClose',value);
	                    value = this.component.$node[0].value;
	                    _this.dateChanged(value);
                        $(document.activeElement).blur()
                    }
                });
                _this.picker = _this.input.pickadate('picker');

                elm.addClass('d-none');
                // this.picker.open();
            },
            dateChanged(value) {
                // console.log('dateChanged',value);
                this.$emit('date_selected', value);
            }
        },
        watch: {
	        settings(val){
	        	// console.log('settings changed',settings);
            },
            trigger_open: function (settings,settingsOld) {
                let _this = this;
// console.log('trigger_open',settings,settingsOld);
                if (settings !== settingsOld) {
                	// console.log('open date picker');
                    // console.log('this.picker', this.picker);
                    // console.log('this.input', this.input);
                    _this.picker.open();
                    // console.log('open');
                }
            }
        },
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/DateChooser.vue?dd5a5cb0